import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import getFetchDefaultListOptions from './get-options';
import selectDefaultListId from './select';
import useFetchIdentity from "../../../../identity/web-shell-client/use-query";
import useIsBuyMarketplaceSupported from "../../../use-is-marketplace-supported";
var useGetDefaultList = function useGetDefaultList() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      enabled: true
    },
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled;
  var isMarketplaceSupported = useIsBuyMarketplaceSupported();
  var _useFetchIdentity = useFetchIdentity({
      enabled: enabled,
      select: function select(_ref2) {
        var isLoggedIn = _ref2.isLoggedIn;
        return isLoggedIn;
      }
    }),
    isLoggedIn = _useFetchIdentity.data;
  return useQuery(_objectSpread(_objectSpread({}, getFetchDefaultListOptions({
    isLoggedIn: isLoggedIn
  })), {}, {
    enabled: enabled && isMarketplaceSupported && Boolean(isLoggedIn),
    select: selectDefaultListId
  }));
};
export default useGetDefaultList;